import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=cbe509e2&scoped=true&"
import script from "./ProductCategory.vue?vue&type=script&lang=js&"
export * from "./ProductCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe509e2",
  null
  
)

component.options.__file = "ProductCategory.vue"
export default component.exports